import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const tiers = [{
  name: 'THE PRESENCE',
  subtitle: 'Core Web Architecture',
  price: '$1,500',
  description: 'For businesses that need a high-performance foundation.',
  features: ['Custom high-performance website', 'Mobile-first responsive design', 'Core SEO architecture', 'Performance optimization (<2s load)', '30-day post-launch support'],
  popular: false
}, {
  name: 'THE AUTHORITY',
  subtitle: 'Web + Content Cycle',
  price: '$3,500',
  description: 'For leaders ready to dominate their market segment.',
  features: ['Everything in The Presence', 'Content strategy & brand voice', '3-month content cycle (blog, social, email)', 'Conversion copywriting', 'Monthly performance reports'],
  popular: true
}, {
  name: 'THE EMPIRE',
  subtitle: 'Full Digital Transformation',
  price: '$8,000',
  description: 'The ultimate ecosystem for elite enterprises.',
  features: ['Everything in The Authority', 'Full brand identity system', '6-month content engine', 'Paid media strategy integration', 'Dedicated strategist', 'Priority support & quarterly reviews'],
  popular: false
}];
export function ServicesSection() {
  return <section id="services" className="py-24 md:py-32 bg-[#111111] relative border-y border-white/5" data-id="element-255">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-256">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-20" data-id="element-257">
          <h2 className="font-display text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-258">
            Choose Your Level
          </h2>
          <p className="text-xl text-neutral-400 max-w-2xl mx-auto" data-id="element-259">
            Transparent pricing. Elite execution. No cheap templates.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center" data-id="element-260">
          {tiers.map((tier, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} className={`relative bg-[#0A0A0A] p-8 md:p-10 rounded-sm border ${tier.popular ? 'border-blue-500 lg:-translate-y-4 shadow-[0_0_40px_rgba(59,130,246,0.1)]' : 'border-white/10'} flex flex-col h-full hover:border-white/30 transition-colors`} data-id="element-261">
              {tier.popular && <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-blue-600 text-white text-xs font-bold px-4 py-1 rounded-full tracking-wider" data-id="element-262">
                  MOST POPULAR
                </div>}

              <div className="mb-8" data-id="element-263">
                <h3 className="font-display text-2xl font-bold text-white mb-1" data-id="element-264">
                  {tier.name}
                </h3>
                <p className="text-blue-400 text-sm font-medium mb-6" data-id="element-265">
                  {tier.subtitle}
                </p>
                <p className="text-neutral-400 text-sm mb-6 min-h-[40px]" data-id="element-266">
                  {tier.description}
                </p>
                <div className="flex items-baseline gap-2" data-id="element-267">
                  <span className="text-neutral-400 text-sm" data-id="element-268">Starting at</span>
                  <span className="font-display text-4xl font-bold text-white" data-id="element-269">
                    {tier.price}
                  </span>
                </div>
              </div>

              <ul className="space-y-4 mb-10 flex-grow" data-id="element-270">
                {tier.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start gap-3" data-id="element-271">
                    <Check size={18} className="text-blue-500 shrink-0 mt-0.5" data-id="element-272" />
                    <span className="text-neutral-300 text-sm" data-id="element-273">{feature}</span>
                  </li>)}
              </ul>

              <a href="#contact" className={`w-full py-4 text-center rounded-sm font-medium transition-all ${tier.popular ? 'bg-blue-600 hover:bg-blue-500 text-white' : 'bg-white/5 hover:bg-white/10 text-white border border-white/10'}`} data-id="element-274">
                Apply for {tier.name}
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}